import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  DvCountryDropdownElement,
  DvNumberboxElement,
  DvTextboxElement,
} from '@devinco/ui/legacy';

@Injectable({ providedIn: 'root' })
export class AddressSearchFormService {
  readonly formElements = [
    new DvTextboxElement({
      colspan: 12,
      key: 'Address',
      label: 'POI.Address',
    }),
    new DvTextboxElement({
      colspan: 6,
      key: 'PostalNumber',
      label: 'POI.PostalNumber',
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 6,
      key: 'PostalPlace',
      label: 'POI.PostalPlace',
    }),
    new DvNumberboxElement({
      colspan: 12,
      key: 'GPSLat',
      label: 'POI.Lat',
      validators: [Validators.required],
      fieldMask: {
        decimalDigits: 5,
        allowNegativeNumbers: false,
        thousandSeparator: '',
      },
    }),
    new DvNumberboxElement({
      colspan: 12,
      key: 'GPSLon',
      label: 'POI.Lon',
      fieldMask: {
        decimalDigits: 5,
        allowNegativeNumbers: false,
        thousandSeparator: '',
      },
      validators: [Validators.required],
    }),
    new DvCountryDropdownElement({
      key: 'Country',
      hidden: true,
    }),
  ];
}
